import { render } from "./ResourcesComponent.vue?vue&type=template&id=2d4a00d0&scoped=true"
import script from "./ResourcesComponent.vue?vue&type=script&lang=js"
export * from "./ResourcesComponent.vue?vue&type=script&lang=js"

import "../assets/styles/resources.css?vue&type=style&index=0&id=2d4a00d0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4a00d0"]])

export default __exports__